import { bytesToNDigits } from 'lib/bytes';
import React, { useEffect, useState, VFC } from 'react';
import { useDispatch } from 'react-redux';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { downloadArchiveItemRequest, getArchiveItemPreviewRequest, setArchiveItemActive } from 'reactApp/modules/viewer/viewer.module';
import { IArchiveItem } from 'reactApp/modules/viewer/viewer.types';
import { ItemViewerContent } from 'reactApp/ui/Mobile/MobileViewer/MobileViewerArchive/ItemViewerContent';
import { ViewerToolbar } from 'reactApp/ui/Mobile/MobileViewer/ViewerToolbar/ViewerToolbar';
import { OptionsModalArchive } from 'reactApp/ui/Mobile/OptionsModal/OptionsModalArchive';

interface IItemViewerProps {
    item: IArchiveItem;
    archiveId: string;
    storage: EStorageType;
}

export const ItemViewer: VFC<IItemViewerProps> = ({ item, archiveId, storage }) => {
    const dispatch = useDispatch();
    const [showOptions, setShowOptions] = useState(false);
    const onClose = () => dispatch(setArchiveItemActive(null));
    const size = (item.size && bytesToNDigits(item.size, 3).value) || '';

    useEffect(() => {
        if (!item.previewUrl && !item.isEncrypted) {
            dispatch(
                getArchiveItemPreviewRequest({
                    storage,
                    archiveId,
                    itemId: item.path,
                })
            );
        }
    }, [archiveId, dispatch, item.isEncrypted, item.path, item.previewUrl, storage]);

    const handleDownload = () => {
        dispatch(
            downloadArchiveItemRequest({
                storage,
                archiveId,
                itemId: item.path,
            })
        );
    };

    return (
        <>
            <ViewerToolbar
                onClose={onClose}
                ext={item.ext}
                nameWithoutExt={item?.nameWithoutExt || ''}
                subTitle={size}
                onClickOption={() => setShowOptions(true)}
            />
            <ItemViewerContent item={item} />
            {showOptions && (
                <OptionsModalArchive item={item} storage={storage} handleDownload={handleDownload} onClose={() => setShowOptions(false)} />
            )}
        </>
    );
};
